import React from 'react';

const metrics = [
  { valor: '−40%', texto: 'menos tiempo en tareas repetitivas' },
  { valor: '100%', texto: 'vision centralizada del negocio en un mismo lugar' },
  { valor: '24/7', texto: 'control remoto de operaciones y alertas' },
  { valor: '1 app', texto: 'para clientes, citas, facturas, stock y equipo' },
];

const benefits = [
  'Gestiona clientes, citas, facturas, tareas y proyectos sin duplicar información.',
  'Consulta todo desde cualquier lugar, incluso desde tu móvil o desde casa.',
  'Reduce errores, retrabajos y pérdidas de tiempo en procesos manuales.',
  'Recibe alertas inmediatas por Slack cuando algo importante ocurre.',
  'Configura módulos y funciones por negocio y por plan sin tocar el código.',
  'Personaliza la experiencia para cada cliente, taller, reforma, electricista o restaurante.',
];

const plans = [
  { nombre: 'Starter', precio: '29€/mes', detalle: 'Para empezar a ordenar lo esencial.' },
  { nombre: 'Pro', precio: '69€/mes', detalle: 'Ideal para crecer con control de stock y facturación.' },
  { nombre: 'Premium', precio: '119€/mes', detalle: 'Solución completa para negocio con alta operación.' },
  { nombre: 'Custom', precio: 'A medida', detalle: 'Configuración específica para cada operación.' },
];

const steps = [
  ['1. Descubre', 'Analizamos cómo opera tu negocio y qué procesos pierde tiempo.'],
  ['2. Personaliza', 'Activamos solo los módulos y funciones que necesita cada cliente.'],
  ['3. Mejora', 'Reduce errores, mejora la productividad y gana control sin depender de papel ni Excel.'],
];

export default function DemoVenta() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', color: '#0f172a' }}>
      <header style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 45%, #0ea5e9 100%)', color: '#fff', padding: '48px 20px 72px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap', marginBottom: 30 }}>
            <div style={{ fontSize: 28, fontWeight: 800 }}>TRIX</div>
            <a href="/login" style={{ border: '1px solid rgba(255,255,255,0.25)', color: '#fff', textDecoration: 'none', borderRadius: 999, padding: '12px 18px', fontWeight: 700 }}>Ver demo</a>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 0.8fr', gap: 32, alignItems: 'center' }}>
            <div>
              <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.12)', borderRadius: 999, padding: '8px 14px', fontWeight: 700, marginBottom: 16 }}>Ahorra tiempo. Reduce costes. Controla todo.</div>
              <h1 style={{ fontSize: 'clamp(2.8rem, 6vw, 5rem)', lineHeight: 1.05, margin: '0 0 18px' }}>La forma más fácil de gestionar tu negocio sin caos.</h1>
              <p style={{ fontSize: 22, lineHeight: 1.7, maxWidth: 720, margin: '0 0 28px', color: 'rgba(255,255,255,0.9)' }}>
                Trix centraliza clientes, tareas, citas, facturas, almacén, equipo y operaciones para que puedas gestionarlo desde cualquier lugar, incluso a distancia.
              </p>
              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                <a href="/login" style={{ background: '#fff', color: '#1d4ed8', padding: '16px 22px', borderRadius: 14, textDecoration: 'none', fontWeight: 800 }}>Solicitar demo</a>
                <a href="#planes" style={{ border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '16px 22px', borderRadius: 14, textDecoration: 'none', fontWeight: 800 }}>Ver planes</a>
              </div>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 24, padding: 26, backdropFilter: 'blur(8px)' }}>
              <div style={{ fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', opacity: 0.8, marginBottom: 18 }}>Beneficio directo</div>
              <div style={{ fontSize: 52, fontWeight: 900, lineHeight: 1 }}>-40%</div>
              <div style={{ fontSize: 18, marginTop: 12, lineHeight: 1.6 }}>de tiempo perdido en tareas manuales y seguimiento disperso.</div>
              <div style={{ marginTop: 22, display: 'grid', gap: 12 }}>
                <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 12, padding: 14 }}><strong>Clientes</strong><div style={{ opacity: 0.85 }}>Seguimiento y atención centralizada.</div></div>
                <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 12, padding: 14 }}><strong>Operación</strong><div style={{ opacity: 0.85 }}>Control de stock, tareas y facturas.</div></div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '52px 20px 80px' }}>
        <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 18, marginBottom: 56 }}>
          {metrics.map((metric) => (
            <div key={metric.texto} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, padding: 24, boxShadow: '0 18px 45px rgba(15,23,42,0.04)' }}>
              <div style={{ fontSize: 38, fontWeight: 900, marginBottom: 8 }}>{metric.valor}</div>
              <div style={{ color: '#475569', lineHeight: 1.6 }}>{metric.texto}</div>
            </div>
          ))}
        </section>

        <section style={{ marginBottom: 56 }}>
          <div style={{ fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', color: '#2563eb', fontWeight: 800, marginBottom: 10 }}>Por qué funciona</div>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', margin: '0 0 22px' }}>Todo en una sola plataforma, preparado para crecer.</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 18 }}>
            {benefits.map((benefit, index) => (
              <div key={benefit} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, padding: 24 }}>
                <div style={{ width: 38, height: 38, display: 'grid', placeItems: 'center', borderRadius: 12, background: '#dbeafe', color: '#1d4ed8', fontWeight: 900, marginBottom: 10 }}>{index + 1}</div>
                <div style={{ lineHeight: 1.7, color: '#334155' }}>{benefit}</div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 24, padding: 28, boxShadow: '0 18px 45px rgba(15,23,42,0.04)', marginBottom: 56 }}>
          <div style={{ fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', color: '#2563eb', fontWeight: 800, marginBottom: 8 }}>Cómo se hace</div>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', marginTop: 0 }}>Un proceso claro para vender y operar mejor</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 18 }}>
            {steps.map(([titulo, texto]) => (
              <div key={titulo} style={{ border: '1px solid #e2e8f0', borderRadius: 16, padding: 20 }}>
                <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 8 }}>{titulo}</div>
                <div style={{ color: '#475569', lineHeight: 1.7 }}>{texto}</div>
              </div>
            ))}
          </div>
        </section>

        <section id="planes" style={{ marginBottom: 56 }}>
          <div style={{ fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', color: '#2563eb', fontWeight: 800, marginBottom: 10 }}>Planes</div>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', margin: '0 0 22px' }}>Elige la solución que mejor encaja con tu negocio</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 18 }}>
            {plans.map((plan) => (
              <div key={plan.nombre} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, padding: 24, boxShadow: '0 18px 45px rgba(15,23,42,0.04)' }}>
                <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 8 }}>{plan.nombre}</div>
                <div style={{ fontSize: 34, fontWeight: 900, marginBottom: 10 }}>{plan.precio}</div>
                <div style={{ color: '#475569', lineHeight: 1.7 }}>{plan.detalle}</div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ background: 'linear-gradient(135deg, #0f172a, #1d4ed8)', color: '#fff', borderRadius: 26, padding: 32 }}>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', margin: '0 0 12px' }}>¿Listo para convertir la gestión en ventaja competitiva?</h2>
          <p style={{ fontSize: 20, lineHeight: 1.7, color: 'rgba(255,255,255,0.85)', marginBottom: 22 }}>
            No dejes que el negocio dependa de llamadas, WhatsApp sueltos, Excel y tareas dispersas. Trix te ayuda a operar mejor, ahorrar tiempo y ofrecer mejor servicio.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <a href="/login" style={{ background: '#fff', color: '#1d4ed8', textDecoration: 'none', padding: '16px 22px', borderRadius: 12, fontWeight: 800 }}>Solicitar demo</a>
            <a href="#planes" style={{ border: '1px solid rgba(255,255,255,0.3)', color: '#fff', textDecoration: 'none', padding: '16px 22px', borderRadius: 12, fontWeight: 800 }}>Ver planes</a>
          </div>
        </section>
      </main>
    </div>
  );
}
